<template>
  <el-row :gutter="20" class="home-num">
    <el-col :span="6">
      <el-card>
        <div slot="header" class="header">
          <span>专家申请总数</span>
        </div>
        <div class="num" v-text="info.mavinCount"></div>
      </el-card>
    </el-col>

    <el-col :span="6">
      <el-card>
        <div slot="header" class="header">
          <span>专家已入库总数</span>
        </div>
        <div class="num" v-text="info.mavinPutCount"></div>
      </el-card>
    </el-col>

    <el-col :span="6">
      <el-card>
        <div slot="header" class="header">
          <span>抽取申请总数</span>
        </div>
        <div class="num" v-text="info.meetCount"></div>
      </el-card>
    </el-col>

    <el-col :span="6">
      <el-card>
        <div slot="header" class="header">
          <span>抽取已成功总数</span>
        </div>
        <div class="num" v-text="info.meetSyncedCount"></div>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import { countHome } from '@/api/home/admin.js';

export default {
  data() {
    return {
      info: {}
    };
  },
  methods: {
    getData() {
      countHome().then(res => {
        this.info = res;
      });
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.home-num {
  .header {
    font-size: 15px;
  }
  .num {
    text-align: center;
    font-size: 50px;
    line-height: 80px;
  }
}
</style>
